import React from "react";
import {
  Testimonials,
  CaseStudies,
  Contact,
  Footer,
  Hero,
  Process,
  Courses,
  Team,
  CTA,
} from "./container";
import HomeContainer from "./components/HomeContainer";

function Home() {
  return (
    <HomeContainer>
      <Hero />
      <Courses />
      <Process />
      <CTA />
      <CaseStudies />
      <Team />
      <Testimonials />
      <Contact />
      <Footer />
    </HomeContainer>
  );
}

export default Home;
